export { default as ContentfulImage } from "./ContentfulImage";
